import { Col, Modal, Row } from "antd"

export const DemoModal = ({
  open,
  onClose,
  iframeUrl,
  width = "80%",
  height = "90vh",
}) => {
  return (
    <>
      <Modal
        centered
        open={open}
        onCancel={onClose}
        width={width}
        styles={{ body: { height, padding: 0 } }}
        footer={null}
        closable={false}
      >
        <Row style={{ height: "100%" }}>
          <Col span={24}>
            <embed
              src={iframeUrl}
              width="100%"
              height="100%"
              style={{ borderRadius: "8px" }}
            ></embed>
          </Col>
        </Row>
      </Modal>
    </>
  )
}
